import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "lot-matcher" }
const _hoisted_2 = { class: "matcher-layout" }
const _hoisted_3 = { class: "svg-viewer" }
const _hoisted_4 = { class: "svg-controls" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "zoom-level" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["viewBox"]
const _hoisted_9 = ["d", "onClick"]
const _hoisted_10 = ["points", "onClick"]
const _hoisted_11 = ["x", "y", "width", "height", "onClick"]
const _hoisted_12 = ["x", "y", "transform", "font-size"]
const _hoisted_13 = ["x", "y", "transform", "font-size"]
const _hoisted_14 = {
  key: 0,
  class: "manual-drawing"
}
const _hoisted_15 = ["points"]
const _hoisted_16 = ["points"]
const _hoisted_17 = ["cx", "cy", "onClick", "onContextmenu"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["cx", "cy", "data-corner", "onMousedown", "onContextmenu"]
const _hoisted_20 = ["cx", "cy", "onMousedown", "onClick"]
const _hoisted_21 = ["cx", "cy"]
const _hoisted_22 = ["cx", "cy"]
const _hoisted_23 = ["cx", "cy"]
const _hoisted_24 = ["cx", "cy"]
const _hoisted_25 = { class: "lot-assignment" }
const _hoisted_26 = { class: "assignment-header" }
const _hoisted_27 = { class: "progress" }
const _hoisted_28 = {
  key: 0,
  class: "drawing-panel"
}
const _hoisted_29 = { class: "drawing-count" }
const _hoisted_30 = { class: "drawing-actions" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 1,
  class: "selected-element-info"
}
const _hoisted_34 = { class: "info-row" }
const _hoisted_35 = { class: "info-value" }
const _hoisted_36 = { class: "info-row" }
const _hoisted_37 = { class: "info-value" }
const _hoisted_38 = {
  key: 0,
  class: "info-row"
}
const _hoisted_39 = { class: "info-value" }
const _hoisted_40 = { class: "info-row" }
const _hoisted_41 = { class: "info-value" }
const _hoisted_42 = {
  key: 2,
  class: "lot-selector"
}
const _hoisted_43 = { class: "search-box" }
const _hoisted_44 = { class: "lot-list" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "lot-number" }
const _hoisted_47 = { class: "assign-actions" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 3,
  class: "lot-number-adjuster"
}
const _hoisted_50 = { class: "adjuster-section" }
const _hoisted_51 = { class: "control-group" }
const _hoisted_52 = { class: "value-display" }
const _hoisted_53 = { class: "control-group" }
const _hoisted_54 = { class: "value-display" }
const _hoisted_55 = { class: "control-group" }
const _hoisted_56 = { class: "value-display" }
const _hoisted_57 = { class: "control-group" }
const _hoisted_58 = { class: "value-display" }
const _hoisted_59 = { class: "adjuster-section" }
const _hoisted_60 = { class: "control-group" }
const _hoisted_61 = { class: "value-display" }
const _hoisted_62 = { class: "control-group" }
const _hoisted_63 = { class: "value-display" }
const _hoisted_64 = { class: "control-group" }
const _hoisted_65 = { class: "value-display" }
const _hoisted_66 = { class: "control-group" }
const _hoisted_67 = { class: "value-display" }
const _hoisted_68 = {
  key: 4,
  class: "edit-mode"
}
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = {
  key: 2,
  class: "convert-action"
}
const _hoisted_72 = { class: "edit-info" }
const _hoisted_73 = { class: "info-label" }
const _hoisted_74 = { class: "info-value" }
const _hoisted_75 = { class: "info-row" }
const _hoisted_76 = { class: "info-value" }
const _hoisted_77 = { class: "info-row" }
const _hoisted_78 = { class: "info-value" }
const _hoisted_79 = { class: "info-row" }
const _hoisted_80 = { class: "info-value" }
const _hoisted_81 = { class: "info-row" }
const _hoisted_82 = { class: "info-value" }
const _hoisted_83 = {
  key: 5,
  class: "assignments-list"
}
const _hoisted_84 = ["onClick"]
const _hoisted_85 = { class: "item-left" }
const _hoisted_86 = { class: "element-badge" }
const _hoisted_87 = { class: "lot-name" }
const _hoisted_88 = { class: "item-actions" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = ["onClick"]
const _hoisted_91 = {
  key: 0,
  class: "unassigned-count"
}
const _hoisted_92 = {
  key: 6,
  class: "completion-section"
}
const _hoisted_93 = {
  key: 0,
  class: "success-message"
}
const _hoisted_94 = {
  key: 1,
  class: "warning-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[37] || (_cache[37] = _createElementVNode("div", { class: "matcher-header" }, [
      _createElementVNode("h2", null, "Assign Lots to SVG Elements"),
      _createElementVNode("p", null, "Click a detected shape to assign it, or draw a missing lot directly on the map.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleZoomIn,
            title: "Zoom In"
          }, "+"),
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleZoomOut,
            title: "Zoom Out"
          }, "−"),
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleResetView,
            title: "Reset View"
          }, "⟲"),
          _createElementVNode("button", {
            class: _normalizeClass(["btn-add-shape", { active: $setup.isDrawing }]),
            disabled: Boolean($setup.editingElement),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isDrawing ? $setup.handleCancelDrawing() : $setup.handleStartDrawing()))
          }, _toDisplayString($setup.isDrawing ? "Cancel Drawing" : "+ Add Lot Shape"), 11, _hoisted_5),
          _createElementVNode("div", _hoisted_6, _toDisplayString(Math.round($setup.zoomLevel * 100)) + "%", 1)
        ]),
        _createElementVNode("div", {
          class: "svg-container",
          ref: "svgContainer",
          onWheel: _withModifiers($setup.handleWheel, ["prevent"]),
          onMousedown: $setup.handleMouseDown,
          onMousemove: $setup.handleMouseMove,
          onMouseup: $setup.handleMouseUp,
          onMouseleave: $setup.handleMouseUp
        }, [
          ($setup.svgContent)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "svg-background",
                innerHTML: $setup.svgContent,
                style: _normalizeStyle($setup.svgStyle)
              }, null, 12, _hoisted_7))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["svg-overlay", { drawing: $setup.isDrawing }]),
            ref: "svgOverlay",
            style: _normalizeStyle($setup.svgStyle),
            viewBox: $setup.overlayViewBox,
            onClick: $setup.handleDrawingPoint
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.localElements, (element) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: element.elementIndex
              }, [
                ($setup.getElementShapePath(element))
                  ? (_openBlock(), _createElementBlock("path", {
                      key: 0,
                      class: _normalizeClass(["interactive-rect", { selected: $setup.selectedElement?.elementIndex === element.elementIndex, assigned: $setup.isAssigned(element.elementIndex), editing: $setup.editingElement?.elementIndex === element.elementIndex }]),
                      d: $setup.getElementShapePath(element),
                      onClick: _withModifiers(($event: any) => ($setup.handleElementClick(element)), ["stop"])
                    }, null, 10, _hoisted_9))
                  : (element.polygonPoints || ($setup.editingElement?.elementIndex === element.elementIndex && $setup.editingElement.polygonPoints))
                    ? (_openBlock(), _createElementBlock("polygon", {
                        key: 1,
                        class: _normalizeClass(["interactive-rect", { selected: $setup.selectedElement?.elementIndex === element.elementIndex, assigned: $setup.isAssigned(element.elementIndex), editing: $setup.editingElement?.elementIndex === element.elementIndex }]),
                        points: $setup.getPolygonPoints(element),
                        onClick: _withModifiers(($event: any) => ($setup.handleElementClick(element)), ["stop"])
                      }, null, 10, _hoisted_10))
                    : (_openBlock(), _createElementBlock("rect", {
                        key: 2,
                        class: _normalizeClass(["interactive-rect", { selected: $setup.selectedElement?.elementIndex === element.elementIndex, assigned: $setup.isAssigned(element.elementIndex), editing: $setup.editingElement?.elementIndex === element.elementIndex }]),
                        x: $setup.editingElement?.elementIndex === element.elementIndex ? $setup.editingElement.boundingBox.x : element.boundingBox.x,
                        y: $setup.editingElement?.elementIndex === element.elementIndex ? $setup.editingElement.boundingBox.y : element.boundingBox.y,
                        width: $setup.editingElement?.elementIndex === element.elementIndex ? $setup.editingElement.boundingBox.width : element.boundingBox.width,
                        height: $setup.editingElement?.elementIndex === element.elementIndex ? $setup.editingElement.boundingBox.height : element.boundingBox.height,
                        onClick: _withModifiers(($event: any) => ($setup.handleElementClick(element)), ["stop"])
                      }, null, 10, _hoisted_11)),
                ($setup.isAssigned(element.elementIndex) && $setup.getLotNumberForElement(element.elementIndex))
                  ? (_openBlock(), _createElementBlock("text", {
                      key: 3,
                      class: "lot-number-label",
                      x: $setup.getLotNumberX(element),
                      y: $setup.getLotNumberY(element),
                      transform: $setup.getLotNumberTransform(element),
                      "text-anchor": "middle",
                      "dominant-baseline": "middle",
                      "font-size": $setup.LOT_NUMBER_FONT_SIZE,
                      "font-weight": "600",
                      fill: "white",
                      style: {"paint-order":"stroke","stroke":"rgba(0, 0, 0, 0.5)","stroke-width":"2px"},
                      "pointer-events": "none"
                    }, _toDisplayString($setup.getLotNumberForElement(element.elementIndex)), 9, _hoisted_12))
                  : _createCommentVNode("", true),
                ($setup.isAssigned(element.elementIndex) && $setup.getLotSizeForElement(element.elementIndex) && $setup.shouldShowLotSize(element.elementIndex))
                  ? (_openBlock(), _createElementBlock("text", {
                      key: 4,
                      class: "lot-size-label",
                      x: $setup.getLotSizeX(element),
                      y: $setup.getLotSizeY(element),
                      transform: $setup.getLotSizeTransform(element),
                      "text-anchor": "middle",
                      "dominant-baseline": "middle",
                      "font-size": $setup.LOT_SIZE_FONT_SIZE,
                      "font-weight": "600",
                      fill: "white",
                      style: {"paint-order":"stroke","stroke":"rgba(0, 0, 0, 0.5)","stroke-width":"1.5px"},
                      "pointer-events": "none"
                    }, _toDisplayString($setup.getLotSizeForElement(element.elementIndex)), 9, _hoisted_13))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            ($setup.isDrawing)
              ? (_openBlock(), _createElementBlock("g", _hoisted_14, [
                  ($setup.drawingPoints.length >= 3)
                    ? (_openBlock(), _createElementBlock("polygon", {
                        key: 0,
                        class: "drawing-preview",
                        points: $setup.getDrawingPoints()
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true),
                  _createElementVNode("polyline", {
                    class: "drawing-outline",
                    points: $setup.getDrawingPoints()
                  }, null, 8, _hoisted_16),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.drawingPoints, (point, index) => {
                    return (_openBlock(), _createElementBlock("circle", {
                      class: _normalizeClass(["drawing-point", { 'closing-point': index === 0 && $setup.drawingPoints.length >= 3 }]),
                      key: index,
                      cx: point.x,
                      cy: point.y,
                      r: $setup.CORNER_HANDLE_RADIUS,
                      onClick: _withModifiers(($event: any) => (index === 0 && $setup.drawingPoints.length >= 3 && $setup.handleFinishDrawing()), ["stop"]),
                      onContextmenu: _withModifiers(($event: any) => ($setup.handleRemoveDrawingPoint(index)), ["prevent","stop"])
                    }, null, 42, _hoisted_17))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            ($setup.editingElement)
              ? (_openBlock(), _createElementBlock("g", _hoisted_18, [
                  ($setup.editingElement.polygonPoints)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.editingElement.polygonPoints, (point, index) => {
                          return (_openBlock(), _createElementBlock("circle", {
                            class: "corner-handle",
                            key: index,
                            cx: point.x,
                            cy: point.y,
                            r: $setup.CORNER_HANDLE_RADIUS,
                            "data-corner": index,
                            onMousedown: _withModifiers(($event: any) => ($setup.handlePolygonCornerDragStart($event, index)), ["left","stop"]),
                            onContextmenu: _withModifiers(($event: any) => ($setup.handleRemovePolygonPoint(index)), ["prevent","stop"])
                          }, null, 40, _hoisted_19))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getPolygonMidpoints(), (midpoint) => {
                          return (_openBlock(), _createElementBlock("circle", {
                            class: _normalizeClass(["midpoint-handle", { curved: midpoint.curved }]),
                            key: 'mid-' + midpoint.edgeIndex,
                            cx: midpoint.x,
                            cy: midpoint.y,
                            r: $setup.MIDPOINT_HANDLE_RADIUS,
                            onMousedown: _withModifiers(($event: any) => ($setup.handleCurveDragStart($event, midpoint.edgeIndex)), ["left","stop"]),
                            onClick: _withModifiers(($event: any) => ($setup.handleMidpointClick(midpoint.edgeIndex)), ["stop"])
                          }, null, 42, _hoisted_20))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("circle", {
                          class: "corner-handle",
                          cx: $setup.editingElement.boundingBox.x,
                          cy: $setup.editingElement.boundingBox.y,
                          r: $setup.CORNER_HANDLE_RADIUS,
                          "data-corner": "top-left",
                          onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.handleCornerDragStart($event, 'top-left')), ["stop"]))
                        }, null, 40, _hoisted_21),
                        _createElementVNode("circle", {
                          class: "corner-handle",
                          cx: $setup.editingElement.boundingBox.x + $setup.editingElement.boundingBox.width,
                          cy: $setup.editingElement.boundingBox.y,
                          r: $setup.CORNER_HANDLE_RADIUS,
                          "data-corner": "top-right",
                          onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.handleCornerDragStart($event, 'top-right')), ["stop"]))
                        }, null, 40, _hoisted_22),
                        _createElementVNode("circle", {
                          class: "corner-handle",
                          cx: $setup.editingElement.boundingBox.x + $setup.editingElement.boundingBox.width,
                          cy: $setup.editingElement.boundingBox.y + $setup.editingElement.boundingBox.height,
                          r: $setup.CORNER_HANDLE_RADIUS,
                          "data-corner": "bottom-right",
                          onMousedown: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.handleCornerDragStart($event, 'bottom-right')), ["stop"]))
                        }, null, 40, _hoisted_23),
                        _createElementVNode("circle", {
                          class: "corner-handle",
                          cx: $setup.editingElement.boundingBox.x,
                          cy: $setup.editingElement.boundingBox.y + $setup.editingElement.boundingBox.height,
                          r: $setup.CORNER_HANDLE_RADIUS,
                          "data-corner": "bottom-left",
                          onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.handleCornerDragStart($event, 'bottom-left')), ["stop"]))
                        }, null, 40, _hoisted_24)
                      ], 64))
                ]))
              : _createCommentVNode("", true)
          ], 14, _hoisted_8))
        ], 544)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("h3", null, _toDisplayString($setup.isDrawing ? "Draw Lot Shape" : $setup.selectedElement ? "Assign Lot" : "Select an Element"), 1),
          _createElementVNode("div", _hoisted_27, _toDisplayString($setup.assignedCount) + " / " + _toDisplayString($setup.localElements.length) + " assigned", 1)
        ]),
        ($setup.isDrawing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _cache[14] || (_cache[14] = _createElementVNode("h4", null, "Create a polygon", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("p", null, "Click around the missing lot to place its corners. Select the first point or press Enter to finish, then adjust any straight or curved edges before assigning the lot.", -1)),
              _createElementVNode("div", _hoisted_29, _toDisplayString($setup.drawingPoints.length) + " point" + _toDisplayString($setup.drawingPoints.length === 1 ? "" : "s") + " placed", 1),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "btn-primary",
                  onClick: $setup.handleFinishDrawing,
                  disabled: $setup.drawingPoints.length < 3
                }, "Finish Shape", 8, _hoisted_31),
                _createElementVNode("button", {
                  class: "btn-secondary",
                  onClick: $setup.handleUndoDrawingPoint,
                  disabled: $setup.drawingPoints.length === 0
                }, "Undo Point", 8, _hoisted_32)
              ]),
              _createElementVNode("button", {
                class: "btn-link",
                onClick: $setup.handleCancelDrawing
              }, "Cancel drawing")
            ]))
          : _createCommentVNode("", true),
        ($setup.selectedElement)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "info-label" }, "Element Type", -1)),
                _createElementVNode("div", _hoisted_35, _toDisplayString($setup.selectedElement.type), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "info-label" }, "Element Index", -1)),
                _createElementVNode("div", _hoisted_37, _toDisplayString($setup.selectedElement.elementIndex), 1)
              ]),
              ($setup.selectedElement.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "info-label" }, "SVG ID", -1)),
                    _createElementVNode("div", _hoisted_39, _toDisplayString($setup.selectedElement.id), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_40, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "info-label" }, "Bounding Box", -1)),
                _createElementVNode("div", _hoisted_41, _toDisplayString($setup.selectedElement.boundingBox.width.toFixed(1)) + " × " + _toDisplayString($setup.selectedElement.boundingBox.height.toFixed(1)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.selectedElement && !$setup.editingElement)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("div", { class: "edit-actions" }, [
                _createElementVNode("button", {
                  class: "btn-warning",
                  onClick: $setup.handleStartEdit
                }, "✏️ Edit Rectangle"),
                _createElementVNode("button", {
                  class: "btn-danger",
                  onClick: $setup.handleDeleteElement
                }, "🗑️ Delete Element")
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("label", null, "Select Lot", -1)),
              _createElementVNode("div", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.lotSearch) = $event)),
                  type: "text",
                  placeholder: "Search lots..."
                }, null, 512), [
                  [_vModelText, $setup.lotSearch]
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredLots, (lot) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["lot-item", { selected: $setup.selectedLotId === lot.lotId }]),
                    key: lot.lotId,
                    onClick: ($event: any) => ($setup.handleSelectLot(lot.lotId))
                  }, [
                    _createElementVNode("div", _hoisted_46, "Lot " + _toDisplayString(lot.lotTitle), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["lot-status", `status-${lot.lotStatus.replace(/s+/g, '-').toLowerCase()}`])
                    }, _toDisplayString(lot.lotStatus), 3)
                  ], 10, _hoisted_45))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("button", {
                  class: "btn-primary",
                  onClick: $setup.handleAssign,
                  disabled: !$setup.selectedLotId
                }, "Assign Lot", 8, _hoisted_48),
                _createElementVNode("button", {
                  class: "btn-secondary",
                  onClick: $setup.handleSkipElement
                }, "Skip Element")
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.selectedElement && $setup.isAssigned($setup.selectedElement.elementIndex) && !$setup.editingElement)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _cache[29] || (_cache[29] = _createElementVNode("h4", null, "Adjust Lot Labels", -1)),
              _cache[30] || (_cache[30] = _createElementVNode("h5", null, "Lot Number", -1)),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", null, "Position X", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.lotNumberAdjustments.offsetX) = $event)),
                    type: "range",
                    min: "-50",
                    max: "50",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.lotNumberAdjustments.offsetX,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_52, _toDisplayString($setup.lotNumberAdjustments.offsetX) + "px", 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", null, "Position Y", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.lotNumberAdjustments.offsetY) = $event)),
                    type: "range",
                    min: "-50",
                    max: "50",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.lotNumberAdjustments.offsetY,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_54, _toDisplayString($setup.lotNumberAdjustments.offsetY) + "px", 1)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", null, "Scale", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.lotNumberAdjustments.scale) = $event)),
                    type: "range",
                    min: "0.1",
                    max: "4",
                    step: "0.1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.lotNumberAdjustments.scale,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_56, _toDisplayString($setup.lotNumberAdjustments.scale.toFixed(1)) + "x", 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", null, "Rotation", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.lotNumberAdjustments.rotation) = $event)),
                    type: "range",
                    min: "0",
                    max: "360",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.lotNumberAdjustments.rotation,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_58, _toDisplayString($setup.lotNumberAdjustments.rotation) + "°", 1)
                ])
              ]),
              _cache[31] || (_cache[31] = _createElementVNode("h5", null, "Lot Size", -1)),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", null, "Position X", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.lotSizeAdjustments.offsetX) = $event)),
                    type: "range",
                    min: "-50",
                    max: "50",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.lotSizeAdjustments.offsetX,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_61, _toDisplayString($setup.lotSizeAdjustments.offsetX) + "px", 1)
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", null, "Position Y", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.lotSizeAdjustments.offsetY) = $event)),
                    type: "range",
                    min: "-50",
                    max: "50",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.lotSizeAdjustments.offsetY,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_63, _toDisplayString($setup.lotSizeAdjustments.offsetY) + "px", 1)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", null, "Scale", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.lotSizeAdjustments.scale) = $event)),
                    type: "range",
                    min: "0.1",
                    max: "4",
                    step: "0.1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.lotSizeAdjustments.scale,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_65, _toDisplayString($setup.lotSizeAdjustments.scale.toFixed(1)) + "x", 1)
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", null, "Rotation", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.lotSizeAdjustments.rotation) = $event)),
                    type: "range",
                    min: "0",
                    max: "360",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.lotSizeAdjustments.rotation,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_67, _toDisplayString($setup.lotSizeAdjustments.rotation) + "°", 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.editingElement)
          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
              _createElementVNode("h4", null, "Editing " + _toDisplayString($setup.editingElement.polygonPoints ? "Polygon" : "Rectangle"), 1),
              ($setup.editingElement.polygonPoints)
                ? (_openBlock(), _createElementBlock("p", _hoisted_69, "Drag a midpoint away from its edge to curve it, or back onto the edge to make it straight. Click a midpoint to add a corner, and right-click a corner to remove it."))
                : (_openBlock(), _createElementBlock("p", _hoisted_70, "Drag the corner handles to adjust the rectangle size and position")),
              (!$setup.editingElement.polygonPoints)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                    _createElementVNode("button", {
                      class: "btn-warning",
                      onClick: $setup.handleConvertToPolygon
                    }, "🔷 Convert to Polygon")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_72, [
                ($setup.editingElement.polygonPoints)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.editingElement.polygonPoints, (point, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "info-row",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_73, "Point " + _toDisplayString(index + 1), 1),
                        _createElementVNode("div", _hoisted_74, _toDisplayString(point.x.toFixed(1)) + ", " + _toDisplayString(point.y.toFixed(1)), 1)
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_75, [
                        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "info-label" }, "X Position", -1)),
                        _createElementVNode("div", _hoisted_76, _toDisplayString($setup.editingElement.boundingBox.x.toFixed(1)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _cache[33] || (_cache[33] = _createElementVNode("div", { class: "info-label" }, "Y Position", -1)),
                        _createElementVNode("div", _hoisted_78, _toDisplayString($setup.editingElement.boundingBox.y.toFixed(1)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "info-label" }, "Width", -1)),
                        _createElementVNode("div", _hoisted_80, _toDisplayString($setup.editingElement.boundingBox.width.toFixed(1)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "info-label" }, "Height", -1)),
                        _createElementVNode("div", _hoisted_82, _toDisplayString($setup.editingElement.boundingBox.height.toFixed(1)), 1)
                      ])
                    ], 64))
              ]),
              _createElementVNode("div", { class: "edit-actions-buttons" }, [
                _createElementVNode("button", {
                  class: "btn-primary",
                  onClick: $setup.handleSaveEdit
                }, "✓ Save Changes"),
                _createElementVNode("button", {
                  class: "btn-secondary",
                  onClick: $setup.handleCancelEdit
                }, "Cancel")
              ])
            ]))
          : (!$setup.isDrawing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                _cache[36] || (_cache[36] = _createElementVNode("h4", null, "Assigned Elements", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.assignments, (assignment) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["assigned-item", { active: $setup.selectedElement?.elementIndex === assignment.elementIndex }]),
                    key: assignment.elementIndex,
                    onClick: ($event: any) => ($setup.handleSelectAssignmentFromList(assignment))
                  }, [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, _toDisplayString(assignment.type) + " " + _toDisplayString(assignment.elementIndex), 1),
                      _createElementVNode("div", _hoisted_87, _toDisplayString($setup.getLotName(assignment.lotId)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("button", {
                        class: "btn-edit",
                        title: "Adjust lot number",
                        onClick: _withModifiers(($event: any) => ($setup.handleSelectAssignmentFromList(assignment)), ["stop"])
                      }, "✎", 8, _hoisted_89),
                      _createElementVNode("button", {
                        class: "btn-remove",
                        onClick: _withModifiers(($event: any) => ($setup.handleUnassign(assignment.elementIndex)), ["stop"])
                      }, "×", 8, _hoisted_90)
                    ])
                  ], 10, _hoisted_84))
                }), 128)),
                ($setup.unassignedCount > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString($setup.unassignedCount) + " element(s) not yet assigned", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
        ($setup.assignedCount > 0 && !$setup.isDrawing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
              ($setup.unassignedCount === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_93, "All elements assigned!"))
                : (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString($setup.unassignedCount) + " unassigned element(s) will be permanently removed from the masterplan.", 1)),
              _createElementVNode("button", {
                class: "btn-primary-large",
                onClick: $setup.handleComplete
              }, "Continue to Assign Stages →")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}